import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-page-wrapper b-page-wrapper--gray h-flex h-flex-center" }
const _hoisted_2 = { class: "h-height-100p h-flex h-flex-dir-column h-flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", null, " Sorry, u have no permission to this app ", -1)),
      _createVNode(_component_FwButton, {
        class: "h-mt-20",
        borderRadiusType: "small-border",
        onClick: _ctx.logOut
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('AUTH.LOG_OUT.TITLE')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}